/* unplugin-vue-components disabled */import { render } from "./VideoDetail.vue?vue&type=template&id=821c0c02&scoped=true&ts=true"
import script from "./VideoDetail.vue?vue&type=script&lang=ts"
export * from "./VideoDetail.vue?vue&type=script&lang=ts"

import "./VideoDetail.vue?vue&type=style&index=0&id=821c0c02&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-821c0c02"],['__file',"src/views/videoDetail/VideoDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "821c0c02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('821c0c02', __exports__)) {
    console.log('reload')
    api.reload('821c0c02', __exports__)
  }
  
  module.hot.accept("./VideoDetail.vue?vue&type=template&id=821c0c02&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('821c0c02', render)
  })

}


export default __exports__